export const isVersionAGreaterThanB = (vA: string, vB: string) => {
  const clean = (v: string) => v.split("-")[0].split("~")[0];

  const partsA = clean(vA).split(".").map(Number);
  const partsB = clean(vB).split(".").map(Number);

  for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
    const a = partsA[i] ?? 0;
    const b = partsB[i] ?? 0;
    if (a > b) return true;
    if (a < b) return false;
  }
  return false;
};